<template>
    <section class="page15" id="infografico">
        <div>
            <p class="text-big text-bold" data-aos="fade-up">
                Clique nas caixas de texto em azul para conhecer as ações que você deve colocar em prática:
            </p>
        </div>
        <div class="conteudo">
            <div class="col1">
                <Mandala
                    data-aos="anima-opacity-scale"
                    data-aos-delay="300"
                    :conteudo="conteudo"
                    :selecionado="selecionado"
                    v-on:selectItem="selectItem"
                >
                </Mandala>
            </div>
            <div class="circle-bottom">
                <div class="circle-bottom-circle"></div>
            </div>
            <div class="col2">
                <transition name="fade">
                    <MandalaContent
                        v-if="selecionado != -1"
                        :conteudo="conteudo"
                        :selecionado="selecionado"
                        v-on:fechaModal="fechaModal"
                    >
                    </MandalaContent>
                </transition>
            </div>
        </div>
    </section>
</template>
<script>
import MandalaContent from "../components/MandalaContent.vue";
import Mandala from "../components/Mandala.vue";
export default {
    data() {
        return {
            selecionado: -1,
            indexAtual: -1,
            indexAnterior: -1,
            indexPosterior: -1,
            conteudo: [
                {
                    titulo: "Planejamento",
                    tituloDisplay: "Planejamento",
                    texto:
                        "Realizar o planejamento de maneira formal entre as partes envolvidas, de forma a ampliar a <i>performance</i> e qualidade do projeto, dividindo responsabilidades e maximizando resultados.",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
                {
                    titulo: "Diagnóstico",
                    tituloDisplay: "Diagnóstico",
                    texto:
                        "Identificar claramente qual a situação atual organizacional, de forma a nortear as decisões e os investimentos relacionados a pessoas, processos, tecnologias e governança.",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
                {
                    titulo: "Organização",
                    tituloDisplay: "Organização",
                    texto:
                        "Realizar a preparação organizacional quanto a pessoas, processos, tecnologias e governança nos níveis estratégico, tático e operacional.",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
                {
                    titulo: "Governança",
                    tituloDisplay: "Governança de Proteção de Dados ",
                    texto:
                        "Realizar as ações planejadas nas fases anteriores quanto à proteção de dados pessoais (titulares de dados) e proteção de dados organizacional.",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
                {
                    titulo: "Melhoria contínua",
                    tituloDisplay: "Melhoria contínua",
                    texto:
                        "Medir os resultados obtidos durante a realização do projeto (antes, durante e depois).",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
                {
                    titulo: "Encerramento",
                    tituloDisplay: "Encerramento",
                    texto:
                        "Permitir que o projeto tenha um ciclo estruturado, de forma a reestabelecer um novo programa ou encerrá-lo de acordo com o planejamento original.",
                    url: "img/correto.png",
                    visitado: true,
                    habilitado: true,
                },
            ],
        };
    },
    mounted() {},
    methods: {
        selectItem(value) {
            this.selecionado = -1;
            this.selecionado = value;
        },
        fechaModal() {
            this.selecionado = -1;
        },
    },
    components: {
        Mandala,
        MandalaContent,
    },
};
</script>
<style lang="scss" scoped>
.page15 {
    height: 100%;
    position: relative;
    background-image: url("~@/assets/img/page1-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 80px;
    padding-bottom: 80px;
    .col1 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }
    .conteudo {
        position: relative;
    }
    .circle-bottom {
        visibility: hidden;
        position: relative;
        width: 100%;
        height: 50px;

        &-circle {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60%;
            height: 10%;
            border-radius: 800px / 20px;
            background-color: rgba(0, 0, 0, 0.1);
        }
    }

    @media (max-width: 1100px) {
        .col1 {
            max-width: 100%;
            min-width: 100%;
        }
        .circle {
            margin: 0 auto;
        }

        &-title {
            padding: 20px;
        }

        .circle-bottom {
            height: 100px;

            &-circle {
                border-radius: 800px / 50px;
            }
        }
    }
}
</style>